import {connect} from 'react-redux';
import React, {Component} from 'react';
import autobind from 'autobind-decorator';
import {Button, Input, ListGroupItem} from 'reactstrap';

export const picOrNot = (file, file_name) => {
    if(!file || !file_name)
        return;
    const exts = [
        '.jpg', '.png', '.gif', '.jpeg'
    ]
    const endsWith = (file) => {
        for (let ext of exts) {
            if (file.endsWith(ext))
                return true
        }
        return false
    }
    try {
        if (endsWith(file)) {
            return <img src={file} title={file_name} width="200px" height="auto"></img>
        }
    } catch(err) {

    }
    return <a href={file} target="_blank" rel="noopener noreferrer">{file_name}</a>
}

@connect(state => ({
    auth: state.apa
}))
export default class ReportMeasure extends Component {
    constructor(props) {

        super(props);
        const measure = props.measure;
        const report = props.report;
        const {reportMeasureList} = props
        const catalogCheckpoint = reportMeasureList.find(cc => !!cc.measure && cc.measure === measure.id) || {
            measure: measure.id,
            catalog: report.id,
            free_text: '',
            is_active: false
        };
        this.state = {
            catalogCheckpoint: catalogCheckpoint
        };
    }

    @autobind
    toggleActive() {
        const catalogCheckpoint = {...this.state.catalogCheckpoint};
        const is_active = catalogCheckpoint.is_active;
        const headers = {
            'Content-Type': 'application/json',
            'Authorization': `Token ${this.props.auth.token}`
        };
        if (is_active) {
            // deactivate cc
            catalogCheckpoint.is_active = false;
            fetch(`/api/report_checkpoints/${catalogCheckpoint.id}/`, {headers, method: 'DELETE'}).then(
                () => {
                    this.setState({catalogCheckpoint: catalogCheckpoint})
                    this.props.remove(catalogCheckpoint)
                }
            );
        } else {
            // activate
            catalogCheckpoint.is_active = true;
            delete catalogCheckpoint.file;
            const body = JSON.stringify(catalogCheckpoint);
            fetch('/api/report_checkpoints/', {headers, method: 'POST', body}).then(res => res.json()).then(
                catalogCheckpoint => {
                    this.setState({catalogCheckpoint})
                    this.props.add(catalogCheckpoint)
                }
            );
        }
    }

    @autobind
    onChange(event) {
        const target = event.target;
        const value = target.value;
        this.setState({
            catalogCheckpoint: {...this.state.catalogCheckpoint, free_text: value}
        });
    }

    @autobind
    update() {
        const headers = {
            'Content-Type': 'application/json',
            'Authorization': `Token ${this.props.auth.token}`
        };
        const catalogCheckpoint = this.state.catalogCheckpoint;
        delete catalogCheckpoint.file1;
        delete catalogCheckpoint.file2;
        delete catalogCheckpoint.file3;
        const body = JSON.stringify(this.state.catalogCheckpoint);
        fetch(`/api/report_checkpoints/${this.state.catalogCheckpoint.id}/`, {headers, method: 'PATCH', body}).then(
            res => res.json()).then(cc => this.setState({catalogCheckpoint: cc},
            this.props.update(cc)
        ));
    }

    @autobind
    uploadFile(event) {
        const id = event.currentTarget.dataset.target;
        const formData = new FormData();
        formData.append(`file${id}`, event.target.files[0]);
        const headers = {
            'Authorization': `Token ${this.props.auth.token}`
        };
        fetch(`/api/report_checkpoints/${this.state.catalogCheckpoint.id}/`, {
            headers,
            method: 'PATCH',
            body: formData
        }).then(
            res => res.json()).then(res => this.setState({catalogCheckpoint: res}, this.props.update(res)));
    }

    @autobind
    deleteFile(event) {
        const id = event.currentTarget.dataset.target;
        const headers = {
            'Content-Type': 'application/json',
            'Authorization': `Token ${this.props.auth.token}`
        };
        const target = `file${id}`;
        const body = JSON.stringify({[target]: null});
        fetch(`/api/report_checkpoints/${this.state.catalogCheckpoint.id}/`, {headers, method: 'PATCH', body}).then(
            res => res.json()).then(cc => this.setState({catalogCheckpoint: cc}, this.props.update(cc)));
    }


    render() {

        const measure = this.props.measure;
        const attachments = measure.anhang || [];
        return (<ListGroupItem className={'mt-4 mb-4 ml-5'}>
            <input type='checkbox' checked={this.state.catalogCheckpoint.is_active} onChange={this.toggleActive}/>
            &nbsp;
            {measure.name}
            {this.state.catalogCheckpoint.is_active &&
            <div style={{marginTop: '1em'}}>
                <ul className={'list-unstyled'}>
                    {attachments.map((attachment, idx) => <li key={`attt_${idx}`}>
                        <a href={attachment.file}>{attachment.file}</a>
                    </li>)}
                </ul>
                <Input type='textarea' value={this.state.catalogCheckpoint.free_text} onChange={this.onChange}
                       onBlur={this.update}/>
                <br/>
                {this.state.catalogCheckpoint.file1 &&
                <p>
                    {picOrNot(this.state.catalogCheckpoint.file1, this.state.catalogCheckpoint.file1_name)}
                    <Button style={{'float': 'right'}} color='danger' size={'sm'} onClick={this.deleteFile}
                            data-target='1'>
                        <i className='fa fa-trash'> </i> Anhang löschen
                    </Button>
                </p>}
                {!this.state.catalogCheckpoint.file1 &&
                <Input type='file' onChange={this.uploadFile} data-target='1'/>}
                {this.state.catalogCheckpoint.file2 &&
                <p>
                    {picOrNot(this.state.catalogCheckpoint.file2, this.state.catalogCheckpoint.file2_name)}
                    <Button style={{'float': 'right'}} color='danger' size={'sm'} onClick={this.deleteFile}
                            data-target='2'>
                        <i className='fa fa-trash'> </i> Anhang löschen
                    </Button>
                </p>}
                {this.state.catalogCheckpoint.file1 &&
                !this.state.catalogCheckpoint.file2 &&
                <Input type='file' onChange={this.uploadFile} data-target='2'/>}
                {this.state.catalogCheckpoint.file3 &&
                <p>
                    {picOrNot(this.state.catalogCheckpoint.file3, this.state.catalogCheckpoint.file3_name)}
                    <Button style={{'float': 'right'}} color='danger' size={'sm'} onClick={this.deleteFile}
                            data-target='3'>
                        <i className='fa fa-trash'> </i> Anhang löschen
                    </Button>
                </p>}
                {this.state.catalogCheckpoint.file2 &&
                !this.state.catalogCheckpoint.file3 &&
                <Input type='file' onChange={this.uploadFile} data-target='3'/>}
            </div>}
        </ListGroupItem>);
    }
}
